import React from 'react';
import { Checkbox } from 'antd';
import type { TSubmitProvider } from '../types';
import s from '../s.module.less';

type Props = {
    person: TSubmitProvider;
    first?: boolean;
    last?: boolean;
    // 传入即为可勾选行（choose 屏）；preview 屏只读
    checked?: boolean;
    onToggle?: (checked: boolean) => void;
};

// provider 行：勾选框 + 首字母头像 + 姓名/副标题 + 已邀请标签。
// 已邀请的行留在名单里，勾选框锁定打勾，owner 一眼看得出谁已经发过。
// 整行可点：勾选框本身关掉指针事件，点击一律由行接管，避免 antd Checkbox 自带的
// <label> 和外层 label 嵌套导致一次点击触发两次切换。
export default function PersonRow({ person, first, last, checked, onToggle }: Props) {
    const checkable = !!onToggle && !person.invited;
    const cls = `${s.person}${first ? ` ${s.first}` : ''}${last ? ` ${s.last}` : ''}${
        checkable ? ` ${s.checkable}` : ''
    }`;
    return (
        <div
            className={cls}
            onClick={checkable ? () => onToggle?.(!checked) : undefined}
            onKeyDown={
                checkable
                    ? (e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              onToggle?.(!checked);
                          }
                      }
                    : undefined
            }
            role={checkable ? 'checkbox' : undefined}
            aria-checked={checkable ? !!checked : undefined}
        >
            {!!onToggle && (
                <Checkbox
                    className={s.personCheckbox}
                    checked={person.invited || !!checked}
                    disabled={person.invited}
                />
            )}
            <span className={s.avatar}>{person.initials}</span>
            <span className={s.personBody}>
                <div className={s.personName}>{person.name}</div>
                <div className={s.personSub}>{person.sub}</div>
            </span>
            {person.invited && <span className={s.invitedTag}>Invited</span>}
        </div>
    );
}
